import { Attr, BelongsTo, Model } from "spraypaint";

import ProgramAiring from "shared/resources/ProgramAiring";

import type TvChannel from "./TvChannel";

@Model()
class TvProgramAiring extends ProgramAiring {
  static jsonapiType = "tv_program_airings";

  @Attr() currentAffairs: boolean;

  @BelongsTo() tvChannel: TvChannel;
}

export default TvProgramAiring;
